export class KitSetup {

    Id: number;
    Title: string;
    Manufacturer: string;
    ExpiryDate: Date;

    constructor() { }
}